<mat-toolbar class="menu">
  <button mat-icon-button (click)="changeView('chat')">
    <fa-icon [icon]="faArrowLeft"></fa-icon>
  </button>
</mat-toolbar>

<div *ngIf="user?.doc !== undefined" class="container">
  <img
    [src]="
      user?.doc?.avatar === undefined || user?.doc?.avatar === ''
        ? 'assets/image/default-user-img.jpg'
        : user.doc?.avatar
    "
    alt="avatar-user-contact"
    class="avatar avatar-big"
  />

  <h3>{{ user?.doc?.firstName + " " + user?.doc?.lastName }}</h3>

  <span>{{ user?.doc?.description }}</span>

  <div>
    <!-- <button mat-stroked-button color="warn" (click)="openDialog()">
      Delete user
    </button> -->

    <button
      mat-stroked-button
      color="primary"
      [ngStyle]="{ 'margin-left': '20px' }"
      (click)="cleanChat()"
    >
      clean chat
    </button>
  </div>
</div>

<div *ngIf="user?.doc === undefined" class="container">
  <img src="assets/image/avatar.svg" alt="avatar-default" class="avatar-big" />
  <p>you can see the user you are talking to in this window</p>
</div>
